<script setup lang="ts">
import useBrandAppConfig from '../composables/useBrandAppConfig'
import BrandBlock from './identity/BrandBlock.vue'
import ColorsBlock from './identity/ColorsBlock.vue'
import TypographyBlock from './identity/TypographyBlock.vue'
import VoiceBlock from './identity/VoiceBlock.vue'

defineProps<{
  section: string
}>()

const { identity, updateIdentity, effectiveButtonColor } = useBrandAppConfig()
</script>

<template>
  <div class="flex flex-col">
    <BrandBlock
      v-if="section === 'design-brand'"
      hide-title
      :logo="identity.logo"
      @update:logo="updateIdentity('logo', $event)"
    />

    <ColorsBlock
      v-else-if="section === 'design-colors'"
      hide-title
      :primary="identity.primary"
      :button-color="identity.buttonColor"
      :effective-button-color="effectiveButtonColor"
      @update:primary="updateIdentity('primary', $event)"
      @update:button-color="updateIdentity('buttonColor', $event)"
    />

    <TypographyBlock
      v-else-if="section === 'design-typography'"
      hide-title
      :font-heading="identity.fontHeading"
      :font-body="identity.fontBody"
      @update:font-body="updateIdentity('fontBody', $event)"
      @update:font-heading="updateIdentity('fontHeading', $event)"
    />

    <VoiceBlock v-else-if="section === 'design-voice'" />
  </div>
</template>
